/* KRONEKS: broaden search matching.
   Users type model refs without the dashes Shopify indexes ("mdv107", "gbm2100",
   "gshock", "касио") and get zero results. Expand the query to "original OR variant"
   (Shopify search: AND binds tighter than OR, so this is safe for multi-word queries).
   Used by predictive-search.js and by a submit hook on every /search form. */
(function () {
  var ALIASES = {
    gshock: 'g-shock',
    джишок: 'g-shock',
    жишок: 'g-shock',
    касио: 'casio',
    казио: 'casio',
    ситизен: 'citizen',
    ситизън: 'citizen',
    ориент: 'orient',
    секонда: 'sekonda',
    акурист: 'accurist',
    гес: 'guess',
    едифайс: 'edifice',
    едифис: 'edifice',
    протрек: 'protrek'
  };

  function normalizeToken(t) {
    var lower = t.toLowerCase();
    if (ALIASES[lower]) return ALIASES[lower];
    // model refs typed without the dash: mdv107 -> mdv-107, dw5600 -> dw-5600
    var m = /^([a-z]+)(\d[a-z0-9]*)$/i.exec(t);
    if (m && m[1].length <= 5) return m[1] + '-' + m[2];
    return t;
  }

  window.krExpandQuery = function (q) {
    if (!q) return q;
    var trimmed = q.trim();
    if (!trimmed || / OR /i.test(trimmed)) return q;
    var normalized = trimmed
      .split(/\s+/)
      .map(normalizeToken)
      .join(' ');
    if (normalized.toLowerCase() === trimmed.toLowerCase()) return q;
    return trimmed + ' OR ' + normalized;
  };

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/search') === -1) return;
      var input = form.querySelector('input[name="q"]');
      if (input && input.value) input.value = window.krExpandQuery(input.value);
    },
    true
  );
})();
